export const formValid = (formRefs, errorFields) => {
    console.log(formRefs)
    for (let key in errorFields) {
        console.log(key)
        if (formRefs.hasOwnProperty(key)) formRefs[key].current.classList.add('is-invalid');
    }
}

export const resetFieldsErrors = (formRefs) => {
    for (let key in formRefs) {
        formRefs[key].current.classList.remove('is-invalid');
    }
}